module.exports = __webpack_public_path__ + "img/zhiyinghover.3c127a69.svg";